import { useUnitRecalculationStore } from 'store/useUnitRecalculationStore';

export const useInvestmentRatiosLoading = () => {
  return useUnitRecalculationStore((state) => state.isRecalculating);
};
